import { BOOKINGS_GUIDE } from '../../pages/bookings/guide';
import { TICKETS_GUIDE } from '../../pages/tickets/guide';
import { AUDIENCE_GUIDE } from './content/audience';
import { AUTOMATION_GUIDE } from './content/automation';
import { INBOX_GUIDE } from './content/inbox';
import { DASHBOARD_GUIDE } from './content/dashboard';
import { ACCOUNT_GUIDE } from './content/account';
import { INSIGHTS_GUIDE } from './content/insights';
import type { Guide } from './types';

/** Every module guide, by id. Add a module's guide here and a HelpButton on its pages. */
export const GUIDES: Record<string, Guide> = {
  [BOOKINGS_GUIDE.id]: BOOKINGS_GUIDE,
  [TICKETS_GUIDE.id]: TICKETS_GUIDE,
  [AUDIENCE_GUIDE.id]: AUDIENCE_GUIDE,
  [AUTOMATION_GUIDE.id]: AUTOMATION_GUIDE,
  [INBOX_GUIDE.id]: INBOX_GUIDE,
  [DASHBOARD_GUIDE.id]: DASHBOARD_GUIDE,
  [ACCOUNT_GUIDE.id]: ACCOUNT_GUIDE,
  [INSIGHTS_GUIDE.id]: INSIGHTS_GUIDE
};
